module.exports = __webpack_public_path__ + "img/1.370fe487.jpg";